import { Leaf, Rabbit } from 'lucide-react';
import type { Fragrance } from '../types.js';
import type { FieldSpec } from './EditLink.js';

const options = [
  { value: 'UNKNOWN', label: 'Not verified' },
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
];
export const ethicalFields: FieldSpec[] = [
  {
    key: 'crueltyFree',
    label: 'Cruelty-free',
    type: 'select',
    options,
    seed: 'UNKNOWN',
    empty: null,
  },
  { key: 'vegan', label: 'Vegan', type: 'select', options, seed: 'UNKNOWN', empty: null },
];

export function EthicalTags({
  fragrance,
}: {
  fragrance: Pick<Fragrance, 'crueltyFree' | 'vegan'>;
}) {
  const tags = (
    [
      { key: 'crueltyFree', label: 'Cruelty-free', Icon: Rabbit },
      { key: 'vegan', label: 'Vegan', Icon: Leaf },
    ] as const
  ).filter(({ key }) => fragrance[key] === 'YES');
  if (!tags.length) return null;
  return (
    <ul className="ethical-tags" aria-label="Cruelty-free and vegan status">
      {tags.map(({ key, label, Icon }) => (
        <li key={key} className="ethical-tag is-confirmed">
          <Icon size={14} aria-hidden="true" />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}
